const logoIdentity = (logo) =>
  logo?._id || logo?.key || logo?.url || logo?.thumbnail || logo?.name || null;

export const getUploadedLogo = (responseData, projectId) => {
  const projectLogos = responseData?.project?.logos || [];
  const uploadedLogos = responseData?.uploadedLogos || [];
  const uploadedLogo =
    projectLogos[projectLogos.length - 1] ||
    uploadedLogos[uploadedLogos.length - 1];

  if (!uploadedLogo) return null;

  return {
    ...uploadedLogo,
    project_id: uploadedLogo.project_id || projectId,
  };
};

export const mergeUploadedLogo = (currentLogos, uploadedLogo) => {
  if (!uploadedLogo) return currentLogos || [];

  const uploadedIdentity = logoIdentity(uploadedLogo);
  const logos = Array.isArray(currentLogos) ? currentLogos : [];

  return [
    ...logos.filter((logo) => logoIdentity(logo) !== uploadedIdentity),
    uploadedLogo,
  ];
};
